var map = {
	"./emoji_0.png": "cd87",
	"./emoji_1.png": "a230",
	"./emoji_2.png": "7b1a",
	"./emoji_3.png": "c486",
	"./emoji_4.png": "170e4",
	"./emoji_5.png": "3745",
	"./emoji_6.png": "75c8",
	"./emoji_7.png": "a8c7",
	"./emoji_8.png": "cb75",
	"./emoji_9.png": "0a3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f622";